module.exports = __webpack_public_path__ + "2db1345831c69ee725fa3c12ef891091.MP3";